import AppHeader from '../../../components/AppHeader';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import { useAppContext } from '../../../contexts/auth';
import BaseDashboard from './components/BaseDashboard';
import ChangePeriodModal from './components/ChangePeriodModal';
import PreAdmDashboard from './components/PreAdmDashboard';
import useConsultsDashboard from './useConsultsDashboard';

export default function Home({activeSidebar}: {activeSidebar: string}) {
  const {
    isLoading,
    selectedDashboard,
    handleSelectedDashboardChange,
    companyCode,
    preAdmDashboardData,
    // hasPreAdmDashError,
    periodBeingSelected,
    setPeriodBeingSelected,
    selectedPeriod,
    setSelectedPeriod,
    changePeriodModalShow,
    setChangePeriodModalShow,
    baseDashData,
    finishProcessModalShow,
    setFinishProcessModalShow,
    finishProcess,
    downloadPreAdmOtimizationModalShow,
    setDownloadPreAdmOtimizationModalShow,
    setIsLoading,
    downloadOtimizationBaseModalShow,
    setDownloadOtimizationBaseModalShow,
    finishChecking,
    setFinishCheckingModalShow,
    finishCheckingModalShow,
    autImpData,
    loadImpAutData,
    periodBeingSelectedAutImp,
    setPeriodBeingSelectedAutImp,
    setSelectedPeriodAutImp,
    selectedPeriodAutImp,
  } = useConsultsDashboard();

  const { isDifferentSubdomain } = useAppContext();

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active={activeSidebar} />
      <Transitions>
        <Loader isLoading={isLoading} />

        {!companyCode && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
            Selecione uma empresa para visualizar os dashboards relacionados às consultas.
              </>
            )}
          />
        )}

        {!!companyCode && (
          <>
            <FilterRadioButtonsContainer>
              <FilterRadioButton selected={selectedDashboard === 'preAdm'} onClick={() => handleSelectedDashboardChange('preAdm')}>
              Pré-Admissional (avulso) / Multirotas
              </FilterRadioButton>
              {!isDifferentSubdomain && (
                <FilterRadioButton selected={selectedDashboard === 'base'} onClick={() => handleSelectedDashboardChange('base')}>
                Gestão de Base
                </FilterRadioButton>
              )}
            </FilterRadioButtonsContainer>
            <div>
              <span>
                {selectedDashboard === 'preAdm' ? 'São as roteirizações realizadas para os funcionários que ainda serão admitidos.' : 'São as roteirizações realizadas para os funcionários que já estão admitidos, e já recebem um VT.'}
              </span>
            </div>

            {selectedDashboard === 'preAdm' && (
              <PreAdmDashboard
                dashData={preAdmDashboardData}
                selectedPeriod={selectedPeriod}
                setChangePeriodModalShow={setChangePeriodModalShow}
                downloadPreAdmOtimizationModalShow={downloadPreAdmOtimizationModalShow}
                setDownloadPreAdmOtimizationModalShow={setDownloadPreAdmOtimizationModalShow}
                setIsLoading={setIsLoading}
                autImpData={autImpData}
                loadImpAutData={loadImpAutData}
                periodBeingSelectedAutImp={periodBeingSelectedAutImp}
                setPeriodBeingSelectedAutImp={setPeriodBeingSelectedAutImp}
                setSelectedPeriodAutImp={setSelectedPeriodAutImp}
                changePeriodModalShow={changePeriodModalShow}
                selectedPeriodAutImp={selectedPeriodAutImp}
                selectedDashboard={selectedDashboard}
              />
            )}

            {selectedDashboard === 'base' && (
              <BaseDashboard
                dashData={baseDashData}
                selectedPeriod={selectedPeriod}
                setChangePeriodModalShow={setChangePeriodModalShow}
                finishProcessModalShow={finishProcessModalShow}
                setFinishProcessModalShow={setFinishProcessModalShow}
                finishProcess={finishProcess}
                downloadOtimizationBaseModalShow={downloadOtimizationBaseModalShow}
                setDownloadOtimizationBaseModalShow={setDownloadOtimizationBaseModalShow}
                setIsLoading={setIsLoading}
                finishChecking={finishChecking}
                setFinishCheckingModalShow={setFinishCheckingModalShow}
                finishCheckingModalShow={finishCheckingModalShow}
                autImpData={autImpData}
                loadImpAutData={loadImpAutData}
                periodBeingSelectedAutImp={periodBeingSelectedAutImp}
                setPeriodBeingSelectedAutImp={setPeriodBeingSelectedAutImp}
                setSelectedPeriodAutImp={setSelectedPeriodAutImp}
                changePeriodModalShow={changePeriodModalShow}
                selectedPeriodAutImp={selectedPeriodAutImp}
                selectedDashboard={selectedDashboard}
              />
            )}

            <ChangePeriodModal
              periodBeingSelected={periodBeingSelected}
              setPeriodBeingSelected={setPeriodBeingSelected}
              setSelectedPeriod={setSelectedPeriod}
              changePeriodModalShow={changePeriodModalShow}
              setChangePeriodModalShow={setChangePeriodModalShow}
            />
          </>
        )}
      </Transitions>

    </>
  );
}
